import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { Container, TextLink } from 'components'
import { config } from 'config'

const { SUPPORT_MAIL } = config!

type FourOFourProps = {
  errorCode: '403' | '404'
}

export const FourOFour = (props: FourOFourProps) => {
  const { errorCode } = props

  const accessNotFoundMsg = 'Sorry! It seems you do not have the required permissions to access this page.'
  const pageNotFoundMsg =
    'Sorry! It seems the page you are looking for is not found. Please make sure the correct URL is entered.'

  return (
    <main>
      <Container>
        <div className="flex flex-col w-full items-center my-28">
          <div className="flex flex-row items-center gap-5">
            <ErrorOutlineIcon className="text-6xl text-red-500" />
            <span className="font-semibold text-8xl text-red-500">{errorCode}</span>
          </div>
          <span className="mt-10 font-semibold text-2xl">
            {errorCode === '403' ? accessNotFoundMsg : pageNotFoundMsg}
          </span>
          <span className="mt-5 font-semibold text-xl">
            For any queries please email support at{' '}
            {<TextLink isEmail displayText={SUPPORT_MAIL} hrefLink={SUPPORT_MAIL} />}
          </span>
        </div>
      </Container>
    </main>
  )
}

export default FourOFour
